import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=78e31038&"
import script from "./BaseImage.vue?vue&type=script&lang=ts&"
export * from "./BaseImage.vue?vue&type=script&lang=ts&"
import style0 from "./BaseImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports